/**
 * 存储localStorage
 */
import LS from 'cz-storage'

export const setStore = (name, content, time = 1) => { // time 默认不传 不过期 单位为天
	if (!name) return;
	// LS.put(name, content, time) 
	LS.put(name, content)
}

/**
 * 获取localStorage
 */
export const getStore = name => {
	if (!name) return;
	return LS.get(name)
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
	if (!name) return;
	LS.remove(name)
}